import type { ReactNode } from 'react';
import type { IconType } from 'src/components/shared/elements/modals/ModalIcon';
import type { ModalType } from 'src/models/ModelTypeSchema';
import type { Product } from 'src/models/product/schema';
import { useSharedState } from './useSharedState';

type ExtraModalData = Partial<{
  noticeDate: string | null;
  shouldNotifyArrival?: boolean;
  targetAttributionToken?: string;
  customElement?: ReactNode;
}>;

export type ModalProps = Partial<{
  type: IconType;
  title: string;
  text: string;
  buttonTitle: string;
  textPink: boolean;
  function: () => void;
  product: Product;
  quantity: number;
  extraData: ExtraModalData;
}>;

const useModal = (modalType: ModalType) => {
  const [isVisible, setIsVisible] = useSharedState<boolean>(modalType, false);
  const [modalParams, setModalParams] = useSharedState<ModalProps>('modalParams', { type: 'info' });
  const [ignitionSource, setIgnitionSource] = useSharedState<string>('ignitionSource', '');

  return {
    isVisible,
    setIsVisible,
    ignitionSource,
    modalParams,
    setModalParams,
    setIgnitionSource
  };
};

export { useModal };
